import { Flex, Tag, Typography } from 'antd'
import cn from 'classnames'

import { CategoryIcon } from './categoryIcons'
import { useStyles } from './styles'
import { PermissionSectionView } from './types'

type Props = {
  sections: PermissionSectionView[]
  showGroups: boolean
  activeKey?: string
  onSelect: (key: string) => void
}

export const CategorySidebar = ({
  sections,
  showGroups,
  activeKey,
  onSelect
}: Props) => {
  const { styles } = useStyles()

  return (
    <Flex vertical gap={2} className={styles.sidebar}>
      {sections.map((section, index) => {
        const isFirstOfGroup =
          showGroups && section.groupTitle !== sections[index - 1]?.groupTitle

        return (
          <Flex vertical gap={2} key={section.key}>
            {isFirstOfGroup && (
              <Typography.Text type="secondary" className={styles.groupTitle}>
                {section.groupTitle}
              </Typography.Text>
            )}

            <button
              type="button"
              onClick={() => onSelect(section.key)}
              className={cn(styles.categoryItem, {
                [styles.categoryItemActive]: section.key === activeKey
              })}
            >
              <CategoryIcon sectionKey={section.key} />

              <span className={styles.categoryTitle}>{section.title}</span>

              <Tag
                bordered={false}
                color={section.activeCount ? 'red' : 'default'}
              >
                {section.activeCount}/{section.totalCount}
              </Tag>
            </button>
          </Flex>
        )
      })}
    </Flex>
  )
}
